module.exports = {
  TRANSACTION_TYPE: {
    DEBIT: 'DEBIT',
    SETTLEMENT_DEBIT: 'SETTLEMENT_DEBIT',
    FEE_DEBIT: 'FEE_DEBIT',
    REVERSAL: 'REVERSAL',
    PARTIAL_REVERSAL: 'PARTIAL_REVERSAL',
    INCREMENTAL_AUTH_REVERSAL: 'INCREMENTAL_AUTH_REVERSAL',
    SETTLEMENT_DIRECT_REVERSAL: 'SETTLEMENT_DIRECT_REVERSAL',
    SETTLEMENT_CREDIT: 'SETTLEMENT_CREDIT',
    FEE_REVERSAL: 'FEE_REVERSAL',
    CARD_SETTLEMENT_DEBIT_WEBHOOK: 'CARD_SETTLEMENT_DEBIT_WEBHOOK',
    CREDIT: 'CREDIT'
  },
  CARD_TRANSACTION_SETTLEMENT_STATUS: {
    READY_FOR_SETTLEMENT: 'READY_FOR_SETTLEMENT',
    PICKED_FOR_SETTLEMENT: 'PICKED_FOR_SETTLEMENT',
    SETTLED: 'SETTLED',
    CANCELLED: 'CANCELLED'
  }
};
